import { useEffect, useState } from "react";
import { Pagination, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import styles from "../styles/productMenuList.module.css";
//import ProductMenuListItem from "./productMenuListItem";
import BusinessExperienceListItem from "./businessExperienceListItem";

const ITEMS_PER_PAGE = 20;

export const BusinessExperienceList = ({
  isPast,
  actions,
}: {
  isPast: Boolean;
  actions: Actions & { duplicate?: Function };
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const { isLoading, experiences, experience } = useSelector((state: any) => state.experience);
  // Calculate total pages
  const totalPages = Math.ceil(experiences.length / ITEMS_PER_PAGE);
  // Get current page products
  const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
  const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
  const currentExperiences = experiences.slice(indexOfFirstItem, indexOfLastItem);
  const [experienceList, setExperienceList] = useState([]);
  //on pageload, get all experiences
  useEffect(() => {
    fetchExperiences();
  }, []);

  //after those experiences are refreshed, set our list according to if it's past or upcoming
  useEffect(() => {
    console.log("our experiences", experiences);
    if (isPast) {
      setExperienceList(experiences.filter((exp: any) => isOldEvent(exp)));
    } else {
      setExperienceList(experiences.filter((exp: any) => !isOldEvent(exp)));
    }
  }, [experiences, isPast]);

  //fetch our experiences
  const fetchExperiences = async () => {
    await actions.get();
  };

  //get milliseconds from our wonky string time format
  function isOldEvent(exp: any) {
    // Parse the event time string to get milliseconds to compare to current time
    const period = exp.endTime.slice(-2);
    const time = exp.endTime.slice(0, -3);
    let [hours, minutes] = time.split(":").map(Number);

    // Adjust the hours based on the period (AM/PM)
    if (period === "PM" && hours !== 12) {
      hours += 12;
    } else if (period === "AM" && hours === 12) {
      hours = 0;
    }

    // Parse event end date and adjust time
    const endDate = new Date(exp.eventEndDate);
    endDate.setHours(hours, minutes);

    // Get the current time in milliseconds
    const now = Date.now(); // right now in milliseconds since epoch

    //it was off by a day so this is a very temporary fix until we revamp the date-time management
    //const offset = 24*60*60*1000;

    console.log(endDate, exp.eventEndDate);

    // Return true if the event is old (current time is greater than event end time)
    return now > endDate.getTime();
  }

  // Update page
  const paginate = (pageNumber: number) => setCurrentPage(pageNumber);

  return (
    <div className={styles.wrapper}>
      <Table responsive className="table" style={{ minHeight: "200px" }}>
        <thead className={styles.listHeaderWrapper}>
          <tr>
            <th>Experiences</th>

            <th>Location</th>
            <th>Date</th>
            <th>Time</th>
            {/* <th>Sub-Category</th> */}
            <th className={styles.actionsColumn}>Actions</th>
          </tr>
        </thead>
        <tbody className={styles.bodyWrapper}>
          {experienceList?.map((exp: any, index: any) => (
            <BusinessExperienceListItem key={`${index}-${exp.name}`} experience={exp} actions={actions} />
          ))}
        </tbody>
      </Table>
      <div className={styles.pagination}>
        <span>
          Showing {indexOfFirstItem + 1} to {indexOfLastItem} of {experiences.length} results
        </span>
        <Pagination>
          <Pagination.First onClick={() => paginate(1)} disabled={currentPage === 1} />
          <Pagination.Prev onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} />
          {[...Array(totalPages).keys()].map((number) => (
            <Pagination.Item key={number + 1} active={number + 1 === currentPage} onClick={() => paginate(number + 1)}>
              {number + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} />
          <Pagination.Last onClick={() => paginate(totalPages)} disabled={currentPage === totalPages} />
        </Pagination>
      </div>
    </div>
  );
};
